import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Row,
} from "reactstrap";

//Context
import { useAuth } from "context/auth";

//Services
import { InputCEP, InputCPF } from "../../../services/mask";
import { InputTELEFONE } from "../../../services/mask";
import { showMessage } from "../../../services/message";
import { GetCEPViaCEP } from "../../../services/viaCep";
import TextField from "../../../components/TextField/TextField";

//API
import { api_PUT } from "../../../services/api_service";
import { api_POST } from "../../../services/api_service";

//Helpers
import { isValidCNPJ } from "../../../helpers/valid";
import { isValidCPF } from "../../../helpers/valid";
import mascaras from "../../../helpers/mascaras";

export default function ExecutorObra({
  item,
  opcao,
  handleProximoStep,
  handleStepAnterior,
}) {
  const { session, setLoading } = useAuth();
  const [registro, setRegistro] = useState(null);
  const [permiteEditar, set_permiteEditar] = useState(true);
  const { register, handleSubmit, errors, setValue, clearErrors } = useForm({
    mode: "onBlur",
  });

  useEffect(() => {
    if (
      session != null &&
      session.tipoAcesso === "AreaRestrita" &&
      item != null
    )
      set_permiteEditar(true);

    if (item) {
      setRegistro(item);
      const obraData = getExecutorObra();
      if (obraData) setAllValues(obraData);
    }
  }, [item]);

  const [cpfCnpj, setCpfCnpj] = useState("");

  const getExecutorObra = () => {
    const isRequerimento = opcao.tipoCadastro === "Requerimento";
    const executorObra = isRequerimento
      ? item?.requerimentoGerador?.[0]?.requerimentoGeradorExecutorObras
      : item?.protocoloGerador?.[0]?.protocoloGeradorExecutorObras;

    return executorObra?.length ? executorObra[0] : null;
  };

  const setAllValues = (dados) => {
    const fields = [
      "cpf_Cnpj",
      "razaoSocial",
      "fantasia",
      "telefone",
      "email",
      "representanteLegal",
      "cpfRepresentante",
      "funcaoRepresentante",
      "departamentoRepresentante",
      "codigoCNAE",
      "atividadeCNA",
      "cep",
      "logradouro",
      "numero",
      "complemento",
      "bairro",
      "cidade",
      "uf",
      "nomeResponsavelTecnico",
      "cpfResponsavelTecnico",
      "creaResponsavelTecnico",
      "funcaoResponsavelTecnico",
      "departamentoResponsavelTecnico",
      "telefoneResponsavelTecnico",
      "emailResponsavelTecnico",
    ];

    fields.forEach((field) => {
      if (dados[field] !== undefined && dados[field] !== null) {
        setValue(field, dados[field], { shouldValidate: true });
        if (field === "cpf_Cnpj") setCpfCnpj(dados[field] || "");
      }
    });
  };

  function handleCriarObjetoTipoRequerimento(data) {
    const executorObra =
      registro?.requerimentoGerador?.[0]?.requerimentoGeradorExecutorObras?.[0];
    const requerimentoGeradorId =
      registro?.requerimentoGerador?.[0]?.requerimentoGerador_Id;

    return {
      ...executorObra,
      requerimentoGeradoresExecutorObra_Id:
        executorObra?.requerimentoGeradoresExecutorObra_Id ?? 0,
      requerimentoGerador_Id: requerimentoGeradorId,
      cpf_Cnpj: cpfCnpj.replace(/[^0-9]/g, ""),
      razaoSocial: data.razaoSocial,
      fantasia: data.fantasia,
      telefone: data.telefone.replace(/[^0-9]/g, ""),
      email: data.email,
      representanteLegal: data.representanteLegal,
      cpfRepresentante: data.cpfRepresentante.replace(/[^0-9]/g, ""),
      funcaoRepresentante: data.funcaoRepresentante,
      departamentoRepresentante: data.departamentoRepresentante,
      codigoCNAE: data.codigoCNAE,
      atividadeCNA: data.atividadeCNA,
      cep: data.cep.replace(/[^0-9]/g, ""),
      logradouro: data.logradouro,
      numero: data.numero,
      complemento: data.complemento,
      bairro: data.bairro,
      cidade: data.cidade,
      uf: data.uf,
      nomeResponsavelTecnico: data.nomeResponsavelTecnico,
      cpfResponsavelTecnico: data.cpfResponsavelTecnico.replace(/[^0-9]/g, ""),
      creaResponsavelTecnico: data.creaResponsavelTecnico,
      funcaoResponsavelTecnico: data.funcaoResponsavelTecnico,
      departamentoResponsavelTecnico: data.departamentoResponsavelTecnico,
      telefoneResponsavelTecnico: data.telefoneResponsavelTecnico.replace(
        /[^0-9]/g,
        ""
      ),
      emailResponsavelTecnico: data.emailResponsavelTecnico,
    };
  }

  function handleCriarObjetoTipoProtocolo(data) {
    const executorObra =
      registro?.protocoloGerador?.[0]?.protocoloGeradorExecutorObras?.[0];
    const protocoloGeradorId =
      registro?.protocoloGerador?.[0]?.protocoloGerador_Id;

    return {
      ...executorObra,
      protocoloGeradorExecutorObra_Id:
        executorObra?.protocoloGeradorExecutorObra_Id ?? 0,
      protocoloGerador_Id: protocoloGeradorId,
      cpf_Cnpj: cpfCnpj.replace(/[^0-9]/g, ""),
      razaoSocial: data.razaoSocial,
      fantasia: data.fantasia,
      telefone: data.telefone.replace(/[^0-9]/g, ""),
      email: data.email,
      representanteLegal: data.representanteLegal,
      cpfRepresentante: data.cpfRepresentante.replace(/[^0-9]/g, ""),
      funcaoRepresentante: data.funcaoRepresentante,
      departamentoRepresentante: data.departamentoRepresentante,
      codigoCNAE: data.codigoCNAE,
      atividadeCNA: data.atividadeCNA,
      cep: data.cep.replace(/[^0-9]/g, ""),
      logradouro: data.logradouro,
      numero: data.numero,
      complemento: data.complemento,
      bairro: data.bairro,
      cidade: data.cidade,
      uf: data.uf,
      nomeResponsavelTecnico: data.nomeResponsavelTecnico,
      cpfResponsavelTecnico: data.cpfResponsavelTecnico.replace(/[^0-9]/g, ""),
      creaResponsavelTecnico: data.creaResponsavelTecnico,
      funcaoResponsavelTecnico: data.funcaoResponsavelTecnico,
      departamentoResponsavelTecnico: data.departamentoResponsavelTecnico,
      telefoneResponsavelTecnico: data.telefoneResponsavelTecnico.replace(
        /[^0-9]/g,
        ""
      ),
      emailResponsavelTecnico: data.emailResponsavelTecnico,
    };
  }

  const onSubmit = async (data) => {
    const isRequerimento = opcao.tipoCadastro === "Requerimento";

    const erros = [];

    const _cpfCnpj = cpfCnpj?.replace(/\D/g, "");
    if (_cpfCnpj?.length === 11 && !isValidCPF(_cpfCnpj)) {
      erros.push("CPF inválido no campo CNPJ/CPF.");
    } else if (_cpfCnpj?.length === 14 && !isValidCNPJ(_cpfCnpj)) {
      erros.push("CNPJ inválido no campo CNPJ/CPF.");
    } else if (_cpfCnpj?.length !== 11 && _cpfCnpj?.length !== 14) {
      erros.push("Campo CNPJ/CPF deve conter 11 ou 14 dígitos.");
    }

    const cpfRepresentante = data.cpfRepresentante?.replace(/\D/g, "");
    if (cpfRepresentante && !isValidCPF(cpfRepresentante)) {
      erros.push("CPF inválido no campo Representante.");
    }

    const cpfResponsavelTecnico = data.cpfResponsavelTecnico?.replace(
      /\D/g,
      ""
    );
    if (cpfResponsavelTecnico && !isValidCPF(cpfResponsavelTecnico)) {
      erros.push("CPF inválido no campo Responsável Técnico.");
    }

    // Verifica se houve erro
    if (erros.length > 0) {
      showMessage("Atenção", erros.join("\n"), "warning", null);
      return;
    }

    if (isRequerimento) {
      setLoading(true);
      try {
        const objRequerimento = handleCriarObjetoTipoRequerimento(data);

        let resposta;
        if (!!objRequerimento.requerimentoGeradoresExecutorObra_Id) {
          resposta = await api_PUT(
            "RequerimentoGerador/PutRequerimentoGeradorExecutorObra",
            objRequerimento
          );
        } else {
          resposta = await api_POST(
            "RequerimentoGerador/PostRequerimentoGeradorExecutorObra",
            objRequerimento
          );
        }

        const executorObra = resposta?.data;
        const registroAtualizado = { ...registro };

        if (registroAtualizado.requerimentoGerador?.[0]) {
          registroAtualizado.requerimentoGerador[0].requerimentoGeradorExecutorObras =
            [executorObra];
        }

        handleProximoStep(registroAtualizado);
      } catch (error) {
        showMessage(
          "Error",
          error?.menssage ?? "Operação com error",
          "error",
          null
        );
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(true);
      try {
        const objProtocolo = handleCriarObjetoTipoProtocolo(data);
        let resposta;
        if (!!objProtocolo.protocoloGeradorExecutorObra_Id) {
          resposta = await api_PUT(
            "ProtocoloGerador/PutProtocoloGeradorExecutorObra",
            objProtocolo
          );
        } else {
          resposta = await api_POST(
            "ProtocoloGerador/PostProtocoloGeradorExecutorObra",
            objProtocolo
          );
        }

        const executorObra = resposta?.data;
        const registroAtualizado = { ...registro };

        if (registroAtualizado.protocoloGerador?.[0]) {
          registroAtualizado.protocoloGerador[0].protocoloGeradorExecutorObras =
            [executorObra];
        }

        handleProximoStep(registroAtualizado);
      } catch (error) {
        showMessage(
          "Error",
          error?.menssage ?? "Operação com error",
          "error",
          null
        );
      } finally {
        setLoading(false);
      }
    }
  };

  const handleCEP = (event) => {
    clearErrors("cep");

    if (event.target.value.replace(/[^0-9]/g, "").trim().length < 8) {
      setValue("cep", "");
      showMessage(
        "Aviso",
        "Cep inválido. só é permitido preencher com números",
        "error",
        null
      );
      return;
    }

    GetCEPViaCEP(event.target.value).then((result) => {
      setLoading(true);
      if (
        result.status !== 200 ||
        (result.data.hasOwnProperty("erro") && result.data.erro == "true")
      ) {
        showMessage("Aviso", "Cep não localizado", "warning", null);
        setValue("logradouro", "");
        setValue("bairro", "");
        setValue("cidade", "");
        setValue("uf", "");
        setLoading(false);
      } else {
        setValue("logradouro", result.data.logradouro);
        setValue("bairro", result.data.bairro);
        setValue("cidade", result.data.localidade);
        setValue("uf", result.data.uf);
        setLoading(false);
      }
    });
  };

  function handleCPFCNPJ(e) {
    const { name, value } = e.target;
    setCpfCnpj(value);
    setValue(name, value);
  }

  return (
    <Card className="card-stats">
      <CardBody>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Container style={{ maxWidth: "1000px", margin: "0 auto" }}>
            <h2 className="titulo-solicitacao">Executor da Obra</h2>

            <Row>
              <Col md="12" lg={4}>
                <FormGroup>
                  <b>
                    <label>
                      <span className="text-danger">* </span>CPF/CNPJ
                    </label>
                  </b>

                  <TextField
                    type="text"
                    name="cpf_Cnpj"
                    mask={mascaras.cpfcnpjMask}
                    value={cpfCnpj}
                    onChange={handleCPFCNPJ}
                    maxLength={18}
                  />
                </FormGroup>
              </Col>

              <Col md="12" lg={4}>
                <FormGroup>
                  <b>
                    <label>
                      <span className="text-danger">* </span>Razão Social
                    </label>
                  </b>
                  <Input
                    type="text"
                    name="razaoSocial"
                    innerRef={register({
                      required:
                        session != null && session.tipoAcesso === "AreaRestrita"
                          ? false
                          : true,
                    })}
                    readonly={permiteEditar ? false : "readonly"}
                    maxLength="100"
                    autoComplete="off"
                  />
                  {errors.razaoSocial && (
                    <span className="form-control-label text-danger">
                      * Campo Obrigatório
                    </span>
                  )}
                </FormGroup>
              </Col>

              <Col md="12" lg={4}>
                <FormGroup>
                  <b>
                    <label>
                      <span className="text-danger">* </span>Nome Fantasia
                    </label>
                  </b>
                  <Input
                    type="text"
                    name="fantasia"
                    innerRef={register({
                      required:
                        session != null && session.tipoAcesso === "AreaRestrita"
                          ? false
                          : true,
                    })}
                    readonly={permiteEditar ? false : "readonly"}
                    maxLength="100"
                    autoComplete="off"
                  />
                  {errors.fantasia && (
                    <span className="form-control-label text-danger">
                      * Campo Obrigatório
                    </span>
                  )}
                </FormGroup>
              </Col>

              <Col md="12" lg={3}>
                <FormGroup>
                  <b>
                    <label>
                      <span className="text-danger">* </span>Telefone
                    </label>
                  </b>
                  <InputTELEFONE
                    name="telefone"
                    inputRef={register({
                      required:
                        session != null && session.tipoAcesso === "AreaRestrita"
                          ? false
                          : true,
                    })}
                    readonly={permiteEditar ? false : "readonly"}
                    defaultValue={
                      item
                        ? opcao.tipoCadastro === "Requerimento"
                          ? item?.requerimentoGerador?.[0]
                              ?.requerimentoGeradorExecutorObras?.[0]
                              ?.telefone || ""
                          : item?.protocoloGerador?.[0]
                              ?.protocoloGeradorExecutorObras?.[0]?.telefone ||
                            ""
                        : ""
                    }
                    autoComplete="off"
                  />
                  {errors.telefone && (
                    <span className="form-control-label text-danger">
                      * Campo Obrigatório
                    </span>
                  )}
                </FormGroup>
              </Col>

              <Col md="12" lg={6}>
                <FormGroup>
                  <b>
                    <label>
                      <span className="text-danger">* </span>Email
                    </label>
                  </b>
                  <Input
                    type="text"
                    name="email"
                    innerRef={register({
                      required:
                        session != null && session.tipoAcesso === "AreaRestrita"
                          ? false
                          : true,
                    })}
                    readonly={permiteEditar ? false : "readonly"}
                    maxLength="50"
                    autoComplete="off"
                  />
                  {errors.email && (
                    <span className="form-control-label text-danger">
                      * Campo Obrigatório
                    </span>
                  )}
                </FormGroup>
              </Col>

              <Col md="12" lg={3}>
                <FormGroup>
                  <b>
                    <span className="text-danger">* </span>
                    <label>Representante Legal</label>
                  </b>
                  <Input
                    type="text"
                    name="representanteLegal"
                    innerRef={register({
                      required:
                        session != null && session.tipoAcesso === "AreaRestrita"
                          ? false
                          : true,
                    })}
                    readonly={permiteEditar ? false : "readonly"}
                    maxLength="100"
                    autoComplete="off"
                  />
                  {errors.representanteLegal && (
                    <span className="form-control-label text-danger">
                      * Campo Obrigatório
                    </span>
                  )}
                </FormGroup>
              </Col>

              <Col md="12" lg={4}>
                <FormGroup>
                  <b>
                    <span className="text-danger">* </span>
                    <label>CPF Representante</label>
                  </b>
                  <InputCPF
                    name="cpfRepresentante"
                    inputRef={register({ required: true })}
                    autoComplete="off"
                    defaultValue={
                      item
                        ? opcao.tipoCadastro === "Requerimento"
                          ? item?.requerimentoGerador?.[0]
                              ?.requerimentoGeradorExecutorObras?.[0]
                              ?.cpfRepresentante || ""
                          : item?.protocoloGerador?.[0]
                              ?.protocoloGeradorExecutorObras?.[0]
                              ?.cpfRepresentante || ""
                        : ""
                    }
                    readonly={permiteEditar ? false : "readonly"}
                  />
                  {errors.cpfRepresentante && (
                    <span className="form-control-label text-danger">
                      * Campo Obrigatório
                    </span>
                  )}
                </FormGroup>
              </Col>

              <Col md="12" lg={4}>
                <FormGroup>
                  <b>
                    <span className="text-danger">* </span>
                    <label>Função Representante</label>
                  </b>
                  <Input
                    type="text"
                    name="funcaoRepresentante"
                    innerRef={register({
                      required:
                        session != null && session.tipoAcesso === "AreaRestrita"
                          ? false
                          : true,
                    })}
                    readonly={permiteEditar ? false : "readonly"}
                    maxLength="30"
                    autoComplete="off"
                  />
                  {errors.funcaoRepresentante && (
                    <span className="form-control-label text-danger">
                      * Campo Obrigatório
                    </span>
                  )}
                </FormGroup>
              </Col>

              <Col md="12" lg={4}>
                <FormGroup>
                  <b>
                    <span className="text-danger">* </span>{" "}
                    <label>Departamento Representante</label>
                  </b>
                  <Input
                    type="text"
                    name="departamentoRepresentante"
                    innerRef={register({
                      required:
                        session != null && session.tipoAcesso === "AreaRestrita"
                          ? false
                          : true,
                    })}
                    readonly={permiteEditar ? false : "readonly"}
                    maxLength="30"
                    autoComplete="off"
                  />
                  {errors.departamentoRepresentante && (
                    <span className="form-control-label text-danger">
                      * Campo Obrigatório
                    </span>
                  )}
                </FormGroup>
              </Col>

              <Col md="12" lg={4}>
                <FormGroup>
                  <b>
                    <span className="text-danger">* </span>
                    <label>Código CNAE</label>
                  </b>
                  <Input
                    type="text"
                    name="codigoCNAE"
                    innerRef={register({
                      required:
                        session != null && session.tipoAcesso === "AreaRestrita"
                          ? false
                          : true,
                    })}
                    readonly={permiteEditar ? false : "readonly"}
                    maxLength="10"
                    autoComplete="off"
                  />
                  {errors.codigoCNAE && (
                    <span className="form-control-label text-danger">
                      * Campo Obrigatório
                    </span>
                  )}
                </FormGroup>
              </Col>

              <Col md="12" lg={4}>
                <FormGroup>
                  <b>
                    <span className="text-danger">* </span>{" "}
                    <label>Atividade CNA</label>
                  </b>
                  <Input
                    type="text"
                    name="atividadeCNA"
                    innerRef={register({
                      required:
                        session != null && session.tipoAcesso === "AreaRestrita"
                          ? false
                          : true,
                    })}
                    readonly={permiteEditar ? false : "readonly"}
                    maxLength="100"
                    autoComplete="off"
                  />
                  {errors.atividadeCNA && (
                    <span className="form-control-label text-danger">
                      * Campo Obrigatório
                    </span>
                  )}
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md={12} lg={12}>
                <h4
                  style={{
                    borderBottom: "solid 1px #ccc",
                    width: "100%",
                  }}
                >
                  Endereço
                </h4>
              </Col>
            </Row>
            <Row>
              <Col md="12" lg={2}>
                <FormGroup>
                  <b>
                    <span className="text-danger">* </span> <label>CEP</label>
                  </b>
                  <InputCEP
                    name="cep"
                    inputRef={register({
                      required:
                        session != null && session.tipoAcesso === "AreaRestrita"
                          ? false
                          : true,
                    })}
                    readonly={permiteEditar ? false : "readonly"}
                    defaultValue={
                      item
                        ? opcao.tipoCadastro === "Requerimento"
                          ? item?.requerimentoGerador?.[0]
                              ?.requerimentoGeradorExecutorObras?.[0]?.cep || ""
                          : item?.protocoloGerador?.[0]
                              ?.protocoloGeradorExecutorObras?.[0]?.cep || ""
                        : ""
                    }
                    autoComplete="off"
                    onBlur={handleCEP}
                  />
                  {errors.cep && (
                    <span className="form-control-label text-danger">
                      * Campo Obrigatório
                    </span>
                  )}
                </FormGroup>
              </Col>

              <Col md="12" lg={6}>
                <FormGroup>
                  <b>
                    <span className="text-danger">* </span>
                    <label>Logradouro</label>
                  </b>
                  <Input
                    type="text"
                    name="logradouro"
                    readonly={permiteEditar ? false : "readonly"}
                    innerRef={register({
                      required:
                        session != null && session.tipoAcesso === "AreaRestrita"
                          ? false
                          : true,
                    })}
                    maxLength="100"
                    autoComplete="off"
                  />
                  {errors.logradouro && (
                    <span className="form-control-label text-danger">
                      * Campo Obrigatório
                    </span>
                  )}
                </FormGroup>
              </Col>

              <Col md="12" lg={4}>
                <FormGroup>
                  <b>
                    <span className="text-danger">* </span>{" "}
                    <label>Bairro</label>
                  </b>
                  <Input
                    type="text"
                    name="bairro"
                    readonly={permiteEditar ? false : "readonly"}
                    innerRef={register({
                      required:
                        session != null && session.tipoAcesso === "AreaRestrita"
                          ? false
                          : true,
                    })}
                    maxLength="100"
                    autoComplete="off"
                  />
                  {errors.bairro && (
                    <span className="form-control-label text-danger">
                      * Campo Obrigatório
                    </span>
                  )}
                </FormGroup>
              </Col>

              <Col md="12" lg={2}>
                <FormGroup>
                  <b>
                    <span className="text-danger">* </span>{" "}
                    <label>Número</label>
                  </b>
                  <Input
                    type="text"
                    name="numero"
                    readonly={permiteEditar ? false : "readonly"}
                    innerRef={register({
                      required:
                        session != null && session.tipoAcesso === "AreaRestrita"
                          ? false
                          : true,
                    })}
                    maxLength="10"
                    autoComplete="off"
                  />
                  {errors.numero && (
                    <span className="form-control-label text-danger">
                      * Campo Obrigatório
                    </span>
                  )}
                </FormGroup>
              </Col>

              <Col md="12" lg={4}>
                <FormGroup>
                  <b>
                    <label>Complemento</label>
                  </b>
                  <Input
                    type="text"
                    name="complemento"
                    innerRef={register()}
                    maxLength="50"
                    autoComplete="off"
                  />
                </FormGroup>
              </Col>

              <Col md="12" lg={4}>
                <FormGroup>
                  <b>
                    <span className="text-danger">* </span>{" "}
                    <label>Cidade</label>
                  </b>
                  <Input
                    type="text"
                    name="cidade"
                    readonly="readonly"
                    innerRef={register({
                      required:
                        session != null && session.tipoAcesso === "AreaRestrita"
                          ? false
                          : true,
                    })}  
                    maxLength="100"
                    autoComplete="off"
                  />
                  {errors.cidade && (
                    <span className="form-control-label text-danger">
                      * Campo Obrigatório
                    </span>
                  )}
                </FormGroup>
              </Col>

              <Col md="12" lg={2}>
                <FormGroup>
                  <b>
                    <span className="text-danger">* </span>
                    <label>UF</label>
                  </b>
                  <Input
                    type="text"
                    name="uf"
                    readonly="readonly"
                    innerRef={register({
                      required:
                        session != null && session.tipoAcesso === "AreaRestrita"
                          ? false
                          : true,
                    })}
                    maxLength="2"
                    autoComplete="off"
                  />
                  {errors.uf && (
                    <span className="form-control-label text-danger">
                      * Campo Obrigatório
                    </span>
                  )}
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md={12} lg={12}>
                <h4
                  style={{
                    borderBottom: "solid 1px #ccc",
                    width: "100%",
                  }}
                >
                  Dados do Responsável Técnico da Obra
                </h4>
              </Col>
            </Row>
            <Row>
              <Col md="12" lg={6}>
                <FormGroup>
                  <b>
                    <label>
                      <span className="text-danger">* </span>Nome Responsável
                      Técnico
                    </label>
                  </b>
                  <Input
                    type="text"
                    name="nomeResponsavelTecnico"
                    innerRef={register({
                      required:
                        session != null && session.tipoAcesso === "AreaRestrita"
                          ? false
                          : true,
                    })}
                    maxLength="100"
                    autoComplete="off"
                    readonly={permiteEditar ? false : "readonly"}
                  />
                  {errors.nomeResponsavelTecnico && (
                    <span className="form-control-label text-danger">
                      * Campo Obrigatório
                    </span>
                  )}
                </FormGroup>
              </Col>

              <Col md="12" lg={3}>
                <FormGroup>
                  <b>
                    <label>
                      <span className="text-danger">* </span>CPF Responsável
                      Técnico
                    </label>
                  </b>
                  <InputCPF
                    name="cpfResponsavelTecnico"
                    inputRef={register({ required: true })}
                    autoComplete="off"
                    readonly={permiteEditar ? false : "readonly"}
                    defaultValue={
                      item
                        ? opcao.tipoCadastro === "Requerimento"
                          ? item?.requerimentoGerador?.[0]
                              ?.requerimentoGeradorExecutorObras?.[0]
                              ?.cpfResponsavelTecnico || ""
                          : item?.protocoloGerador?.[0]
                              ?.protocoloGeradorExecutorObras?.[0]
                              ?.cpfResponsavelTecnico || ""
                        : ""
                    }
                  />
                  {errors.cpfResponsavelTecnico && (
                    <span className="form-control-label text-danger">
                      * Campo Obrigatório
                    </span>
                  )}
                </FormGroup>
              </Col>

              <Col md="12" lg={3}>
                <FormGroup>
                  <b>
                    <label>
                      <span className="text-danger">* </span>CREA Responsável
                      Técnico
                    </label>
                  </b>
                  <Input
                    type="text"
                    name="creaResponsavelTecnico"
                    readonly={permiteEditar ? false : "readonly"}
                    innerRef={register({
                      required:
                        session != null && session.tipoAcesso === "AreaRestrita"
                          ? false
                          : true,
                    })}
                    maxLength="50"
                    autoComplete="off"
                  />
                  {errors.creaResponsavelTecnico && (
                    <span className="form-control-label text-danger">
                      * Campo Obrigatório
                    </span>
                  )}
                </FormGroup>
              </Col>

              <Col md="12" lg={4}>
                <FormGroup>
                  <b>
                    <label>
                      <span className="text-danger">* </span>Função Responsável
                      Técnico
                    </label>
                  </b>
                  <Input
                    type="text"
                    readonly={permiteEditar ? false : "readonly"}
                    name="funcaoResponsavelTecnico"
                    innerRef={register({
                      required:
                        session != null && session.tipoAcesso === "AreaRestrita"
                          ? false
                          : true,
                    })}
                    maxLength="30"
                    autoComplete="off"
                  />
                  {errors.funcaoResponsavelTecnico && (
                    <span className="form-control-label text-danger">
                      * Campo Obrigatório
                    </span>
                  )}
                </FormGroup>
              </Col>

              <Col md="12" lg={4}>
                <FormGroup>
                  <b>
                    <label>
                      <span className="text-danger">* </span>Departamento
                      Responsável Técnico
                    </label>
                  </b>
                  <Input
                    type="text"
                    name="departamentoResponsavelTecnico"
                    innerRef={register({
                      required:
                        session != null && session.tipoAcesso === "AreaRestrita"
                          ? false
                          : true,
                    })}
                    readonly={permiteEditar ? false : "readonly"}
                    maxLength="30"
                    autoComplete="off"
                  />
                  {errors.departamentoResponsavelTecnico && (
                    <span className="form-control-label text-danger">
                      * Campo Obrigatório
                    </span>
                  )}
                </FormGroup>
              </Col>

              <Col md="12" lg={4}>
                <FormGroup>
                  <b>
                    <label>
                      <span className="text-danger">* </span>Telefone
                      Responsável Técnico
                    </label>
                  </b>
                  <InputTELEFONE
                    name="telefoneResponsavelTecnico"
                    inputRef={register({
                      required:
                        session != null && session.tipoAcesso === "AreaRestrita"
                          ? false
                          : true,
                    })}
                    readonly={permiteEditar ? false : "readonly"}
                    defaultValue={
                      item
                        ? opcao.tipoCadastro === "Requerimento"
                          ? item?.requerimentoGerador?.[0]
                              ?.requerimentoGeradorExecutorObras?.[0]
                              ?.telefoneResponsavelTecnico || ""
                          : item?.protocoloGerador?.[0]
                              ?.protocoloGeradorExecutorObras?.[0]
                              ?.telefoneResponsavelTecnico || ""
                        : ""
                    }
                    autoComplete="off"
                  />
                  {errors.telefoneResponsavelTecnico && (
                    <span className="form-control-label text-danger">
                      * Campo Obrigatório
                    </span>
                  )}
                </FormGroup>
              </Col>

              <Col md="12" lg={12}>
                <FormGroup>
                  <b>
                    <label>
                      <span className="text-danger">* </span>Email Responsável
                      Técnico
                    </label>
                  </b>
                  <Input
                    type="email"
                    name="emailResponsavelTecnico"
                    readonly={permiteEditar ? false : "readonly"}
                    innerRef={register({
                      required:
                        session != null && session.tipoAcesso === "AreaRestrita"
                          ? false
                          : true,
                    })}
                    maxLength="50"
                    autoComplete="off"
                  />
                  {errors.emailResponsavelTecnico && (
                    <span className="form-control-label text-danger">
                      * Campo Obrigatório
                    </span>
                  )}
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col lg="6" className="text-left">
                <Button
                  color="secundary"
                  onClick={() => handleStepAnterior(registro)}
                  className="btn-mobile"
                  type="submit"
                >
                  <i className="fas fa-chevron-left"></i> Voltar
                </Button>
              </Col>
              <Col lg="6" className="text-right">
                <Button color="success" className="btn-mobile" type="submit">
                  Próxima Etapa <i className="fas fa-chevron-right"></i>
                </Button>
              </Col>
            </Row>
          </Container>
        </Form>
      </CardBody>
    </Card>
  );
}
